/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { Base } from "./Base";

/**
 * 
 * @export
 * @interface FormDefinition
 */
export interface FormDefinition {
    /**
     * When was the entity created
     * @type {Date}
     * @memberof FormDefinition
     */
    created_at: Date;
    /**
     * When was the entity updated
     * @type {Date}
     * @memberof FormDefinition
     */
    updated_at: Date;
    /**
     * Status for form definition initialization (creation).
     * @type {string}
     * @memberof FormDefinition
     */
    creation_status: FormDefinitionCreationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FormDefinition
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinition
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinition
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinition
     */
    owner_id: string;
    /**
     * ID of my own preview form (if available)
     * @type {string}
     * @memberof FormDefinition
     */
    preview_form_id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormDefinition
     */
    standard_id: string;
    /**
     * 
     * @type {number}
     * @memberof FormDefinition
     */
    with_condition_count: number;
}




/**
* @export
* @enum {string}
*/
export enum FormDefinitionCreationStatusEnum {
    FINISHEDFAIL = 'FINISHED_FAIL',
    FINISHEDSUCCESS = 'FINISHED_SUCCESS',
    INPROGRESS = 'IN_PROGRESS',
    INQUEUE = 'IN_QUEUE'
}


